import Vue from "vue";
import "./plugins/axios";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import moment from "moment";
import "./assets/scss/all.scss";

import "@ag-grid-community/client-side-row-model";
import "@ag-grid-community/infinite-row-model";
import "@ag-grid-community/csv-export";
import {SessionStorage} from "@/common/util";

import Enlang from "element-ui/lib/locale/lang/en";
import Delang from "element-ui/lib/locale/lang/de";
import {LicenseManager} from "@ag-grid-enterprise/core";
import pdf from "vue-pdf";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import DashboardPlugin from "./material-dashboard";
import Cookies from "js-cookie";
import VueMeta from "vue-meta";

import {userApi} from "@/common/api/userApi";

import {localization} from "@/common/lang/localization";

import "@/validation/index";

import Swal from "sweetalert2";
import {formatAsLocalizedEnum} from "@/common/format";
import {enumDef} from "@/common/enumDefs";
import {mapActions, mapMutations} from "vuex";
import {commonApi} from "@/common/api/commonApi";
// const licenKey="TrustBills_GmbH_TrustBills_Platform_2Devs1_SaaS_31_July_2019__MTU2NDUyNzYwMDAwMA==53cb0a736669b97a6a5b863eef5e6e4b"
const licenKey = "CompanyName=TrustBills Technologies GmbH,LicensedApplication=TrustBills Platform,LicenseType=SingleApplication,LicensedConcurrentDeveloperCount=2,LicensedProductionInstancesCount=1,AssetReference=AG-007222,ExpiryDate=5_March_2021_[v2]_MTYxNDkwMjQwMDAwMA==d0be26220d5c23b2436df4b16cdf1f86"

LicenseManager.setLicenseKey(
    licenKey
);
const i18n = localization.i18n;

const _ = require("lodash");
Vue.use(pdf);

window.moment = moment;
window.moment.locale(localization.currentLang());

Vue.prototype.$sessionStorage = SessionStorage;

Vue.use(VueMeta, {
    refreshOnceOnNavigation: true
})

Vue.mixin({
    methods: {
        ...mapActions(["setActionLoggedIn"]),
        ...mapMutations({
            initBaseState:"initBaseState",
            initCompletionState:"initCompletionState",
            initExchangeState:"initExchangeState",
            initAlfaState:"alfa/initState",
            initInvestorState:"initInvestorState",
            initReceivablesState:"initReceivablesState",
            initSellerState:"initSellerState",
            initSessionState:"session/initState"
        }),
        logout() {
            userApi.Logout();
            this.setActionLoggedIn(false);
            this.removeCookie("session-timeout");
            this.removeCookie("XSRF-TOKEN");
            this.$sessionStorage.remove('localeUser');
            this.initBaseState();
            this.initCompletionState();
            this.initExchangeState();
            this.initAlfaState();
            this.initInvestorState();
            this.initReceivablesState();
            this.initSellerState();
            this.initSessionState();
            this.$router.replace("/login").then(() => {
                if (this.$store.state.base.version.outdated) {
                    window.location.reload();
                }
            });
        },
        setLanguage(lang) {
            this.$i18n.locale = lang;
            this.setCookie("language", lang);
            commonApi.localeLang().catch(this.toast);

            location.reload();
        },
        setCountry(key) {
            return this.$t(`common.country.${key}`)
        },
        setCookie(key, data) {
            Cookies.set(key, data);
        },
        getCookie(key) {
            return Cookies.get(key);
        },
        removeCookie(key) {
            Cookies.remove(key);
        },
        toast(message, type = "danger") {
            if (!message) {
                return;
            }

            // By default the final msg is just the message as given
            let finalMsg = message;

            // Try to convert the different kind of response formats into a proper display format
            if (message instanceof Array) {
                finalMsg = message.join("</br>");
            } else if (message instanceof Object) {
                finalMsg = "";
                for (let key in message) {
                    let value = message[key];
                    if (value instanceof Array) {
                        finalMsg += key + ": " + value.join(",") + "</br>";
                    } else if (value instanceof Number) {
                        finalMsg += value + "x " + key + "</br>";
                    } else {
                        finalMsg += key + ": " + value + "</br>";
                    }
                }
            } else if (typeof message === "string" && message.startsWith("[") && message.endsWith("]")) {
                finalMsg = message.replace("[", "").replace("]", "").replaceAll(",", "</br>");
            }

            this.$notifyMsg({
                message: finalMsg,
                icon: "add_alert",
                horizontalAlign: "center",
                verticalAlign: "top",
                type: type
            });
        },
        toastSuccess(message) {
            this.toast(message || this.$t('common.success'), "success");
        },
        formatMoney(value, symbol = '', decimal = 2) {
            return accounting.formatMoney(
                value,
                symbol,
                decimal
            );
        },
        millionFormat(value) {
            // 1000000
            if (value && value >= 1000000) {
                value = value / 1000000
            }
            return this.formatMoney(value)

        },
        isMillion(value) {
            if (value && value >= 1000000) {
                return true
            } else {
                return false
            }
        },
        yesFun(data) {
            if (data) {
                return this.$t('common.yes')
            } else {
                return this.$t('common.no')

            }

        },
        getDetailType(type) {
            return formatAsLocalizedEnum(enumDef.receivableType, type);
        },
        SwalCofirm(data) {
            Swal.fire({
                title: data.title,
                text: data.text,
                type: data.type || '',
                showCancelButton: data.showCancelButton === false ? false : true,
                confirmButtonClass: "md-button md-success",
                cancelButtonClass: "md-button md-danger",
                confirmButtonText: data.confirmButtonText ? data.confirmButtonText : this.$t('common.button.cancel'),
                cancelButtonText: data.cancelButtonText ? data.cancelButtonText : this.$t('signUp.Continue'),
                buttonsStyling: false
            }).then(result => {
                if (result.value) {
                    if (data.confirmFun) {
                        data.confirmFun(data.params)
                    }
                }
            });
        },
        alert(data, isHtml = false) {
            this.$alert(data.msg || '', data.title || '', {
                confirmButtonText: data.confirmButtonText || this.$t('common.button.continue'),
                confirmButtonClass: data.confirmButtonClass || "md-primary",
                dangerouslyUseHTMLString: isHtml
            }).then(() => {
                if (data.confirmFun) {
                    data.confirmFun(data.params)
                }
            });
        },
        confirmMeg(data, isHtml = false, type = '') {
            // warning
            this.$confirm(data.msg || '', data.title || '', {
                confirmButtonText: data.confirmButtonText || this.$t('common.button.continue'),
                confirmButtonClass: data.confirmButtonClass || "md-primary",
                cancelButtonText: data.cancelButtonText || this.$t('common.button.cancel'),
                cancelButtonClass: "md-blank",
                type: type,
                dangerouslyUseHTMLString: isHtml,
                customClass: data.customClass
            }).then(() => {
                if (data.confirmFun) {
                    data.confirmFun(data.params)
                }
            }).catch(() => {
                if (data.cancelFun) {
                    data.cancelFun();
                }
            });
        },
        buildHintBoxForConfirmation(text, withHintText = true) {
          return "<div class='text_left light_bg_color'>" +
                      (withHintText
                          ? "<span class='font_bold'>" + this.$t('common.hint') + "：</span>" +
                            "<br/>"
                          : ""
                      ) +
                    "<span>" + text + "</span>" +
                "</div>"
        },
        showHasChangesCloseConfirmation(params = {}) {
            this.$store.dispatch("setActionNoticModal", {
                show: true,
                data: {
                    type: "HasChangesCloseConfirmationModal",
                    width: 425,
                    allowClose: false,
                    closeOnClickOutside: false,
                    data: params
                }
            });
        },
        strengthWith(data) {
            let level = 0;
            let difficulty = [/[a-z]/, /[A-Z]/, /[_!@#$%^&*()]/, /.{8,}/];

            for (let item of difficulty) {
                if (item.test(data)) {
                    level += 1;
                }
            }
            return level;
        },
        dateComparator() {
            // Cancel customization
        },
        $mergeOnlyExistingProps(existingObj, newObj, inline) {
            let mergedObj = inline ? existingObj : {};
            Object.keys(existingObj).forEach(propKey => {
                if (newObj.hasOwnProperty(propKey)) {
                    mergedObj[propKey] = newObj[propKey];
                }
            });
            return mergedObj;
        },
        autocompleteOff() {
            // Since the standard "off" is ignored by Chrome for example we
            // create a unique identifier for autocomplete to make sure browser have not stored any value for this before
            return "off-forced-" + Math.round(Math.random() * 1000000);
        }
    },
    computed: {
        currentUser() {
            return this.$sessionStorage.get("localeUser");
        },
    }
});
Vue.config.productionTip = false;

Vue.use(DashboardPlugin);

let localeLang = localization.currentLang() === enumDef.language.DE ? Delang : Enlang;
Vue.use(ElementUI, {
    locale: localeLang
});

Vue.prototype._ = _;
const setMoneyConfig = () => {
    if (localization.currentLang() === enumDef.language.DE) {
        // eslint-disable-next-line no-undef
        accounting.settings.currency.thousand = ".";
        // eslint-disable-next-line no-undef
        accounting.settings.currency.decimal = ",";
        // eslint-disable-next-line no-undef
        accounting.settings.currency.format = "%v %s";

        // eslint-disable-next-line no-undef
        accounting.settings.number.thousand = ".";
        // eslint-disable-next-line no-undef
        accounting.settings.number.decimal = ",";
    } else {
        // eslint-disable-next-line no-undef
        accounting.settings.currency.thousand = ",";
        // eslint-disable-next-line no-undef
        accounting.settings.currency.decimal = ".";
        // eslint-disable-next-line no-undef
        accounting.settings.currency.format = "%s %v";

        // eslint-disable-next-line no-undef
        accounting.settings.number.thousand = ",";
        // eslint-disable-next-line no-undef
        accounting.settings.number.decimal = ".";
    }
}
setMoneyConfig();

//全局事件响应
new Vue({
    i18n,
    router,
    store,
    render: h => h(App)
}).$mount("#app");